import { DataEvents, Event } from '../types/apiEvents'
import { ProductsList } from '../types/apiProducts'
import { CampaignsList } from '../types/apiCampaign'
// ============== api ============== //

// const API_URL = 'https://mxstella.dp150.xyz/all-events'
const API_URL = `${window.origin}/all-events`
const API_URL_PRODUCT = `${window.origin}/all-productos`
const API_URL_CAMPAIGN = `${window.origin}/all-campaigns`

export const getAllEvents = async () => {
  const res = await fetch(API_URL)
  const data: DataEvents[] = await res.json()
  return data
}

export const getEvents = async (page = 1) => {
  const res = await fetch(`${API_URL}/${page}`)
  const data: DataEvents[] = await res.json()
  return data
}

// https://mxstella.dp150.xyz/all-events/category/1/1
export const getCategoryEvents = async (category: number, page: 1) => {
  // console.log(`${API_URL}/category/${category}/${page}`)
  const res = await fetch(`${API_URL}/category/${category}/${page}`)
  const data: Event[] = await res.json()
  return data
}

export const getProducts = async (page: number = 1) =>{
  const res = await fetch(`${API_URL_PRODUCT}/${page}`)
  const data : ProductsList[] = await res.json()
  return data
}

export const getCampaigns = async (page: number = 1) =>{
  const res = await fetch(`${API_URL_CAMPAIGN}/${page}`)
  const data : CampaignsList[] = await res.json()
  return data
}